export default "__VITE_ASSET__CHmSysrj__"